import PropTypes from "prop-types";
import React from 'react';
import { withSize } from 'react-sizeme'

import Footer from './Footer';
import LooseFooter from './LooseFooter';
import NewFooter from "./NewFooter";

function Layout({ children, id, footer, itemsCenter, additionalClassName, contentAlignment, size }) {

  return (
    <div className={`${ size.height > 800 ? "md:h-auto" : "md:h-screen" } flex flex-col content-end`} >
      <main className={`flex-1 mx-auto flex flex-wrap container content-${contentAlignment}`}>        
        <section id={id} 
          className="w-full h-auto">
          {children}
        </section>
      </main>
      <NewFooter className="flex-initial" />
    </div>
  );
};

Layout.propTypes = {
  additionalClassName: PropTypes.string,
  children: PropTypes.any.isRequired,
  contentAlignment: PropTypes.string,
  footer: PropTypes.string,
  id: PropTypes.any,
  itemsCenter: PropTypes.string
}

export default withSize()(Layout);
